import React from 'react';

import { GameContext } from '../../../../../contexts/game';
import { DropDownList } from '@progress/kendo-react-dropdowns';

export const TeamDropdown: React.FC<{
  selectedTeam: {
    code: string;
    name: string;
  };
  onSelectTeam: (value: { code: string; name: string }) => void;
}> = ({ selectedTeam, onSelectTeam }) => {
  const [game] = React.useContext(GameContext);

  const teams = React.useMemo(() => {
    if (!game.gameState) return [];

    return game.gameState.teams.map((team) => ({
      code: team.code ?? '',
      name: team.name ?? ''
    }));
  }, [game.gameState]);

  return (
    <DropDownList
      className={'reels-team-dropdown'}
      style={{
        borderRadius: '8px',
        backgroundColor: 'white'
      }}
      textField={'name'}
      fillMode={'outline'}
      dataItemKey={'code'}
      value={selectedTeam}
      onChange={(e) => onSelectTeam(e.value)}
      data={[{ code: 'All Teams', name: 'All Teams' }, ...teams]}
    />
  );
};
